// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"231":"8a1f86b9","734":"34927310"}[chunkId] + ".css";
};